import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'clinical-exams',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'clinical-exams-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.clinical-exams-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-exams-index" */ '@/modules/configurations/catalogs/clinical-exams/views/Index.vue')
        },
        {
            path: 'create',
            name: 'clinical-exams-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'clinical-exams-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.clinical-exams-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.clinical-exams-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-exams-create" */ '@/modules/configurations/catalogs/clinical-exams/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'clinical-exams-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'clinical-exams-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.clinical-exams-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.clinical-exams-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-exams-edit" */ '@/modules/configurations/catalogs/clinical-exams/views/Edit.vue')
        }
    ]
}